class Constants {
  public static readonly PROJECT_PATH = '../';

  public static readonly BACKEND_PATH = 'backend/index.php';

  public static readonly LOGIN_BACKEND_PATH = 'backend_login/index.php';

  public static readonly PRODUCT_VERSION = '0.131.0';

  public static readonly EMS_MINUTES_RELOAD_INTERVAL = 120;

  public static readonly PRODUCT_ID = '4755';
}

export default Constants;
